import SelectorFilter from '../hierarchySelector/tree/SelectorFilter'

export default class ReportsUsersSelectorFilter extends SelectorFilter {
    constructor({
        tree,
        searchIndex,
        allActiveSet,
        myTeamNodesSet,
        accessibleParentNodes,
        showTeamOnly = false,
    }) {
        super(tree, searchIndex, allActiveSet)
        this.myTeamNodesSet = myTeamNodesSet
        this.manageableUsersNodeSet = showTeamOnly ? myTeamNodesSet : null
        this.accessibleParentNodes = accessibleParentNodes
    }

    hasNoFilter() {
        return super.hasNoFilter() && !this.manageableUsersNodeSet
    }

    /**
     * Filters nodes of selector according to selected parameters of filter.
     * @returns {TreeNode}
     */
    doFilter() {
        if (!this.manageableUsersNodeSet)
            return super.doFilter()

        let result;
        //keywordSet - set of nodes representing result of search by some specified keyword.
        //If keywordSet is presented then we should return result of search in set of manageable users.
        // Set of selected nodes(selectedOnlySet) is not taken into account when searching.
        if (this.keywordSet) {
            result = this.manageableUsersNodeSet.intersection(this.keywordSet)
            let resultWithActiveOnlySet = this.safeIntersection(result, this.activeOnlySet)

            // If there is no active users or groups with a specified keyword found
            // then return result of search in non-active and manageable users
            result = resultWithActiveOnlySet.isEmpty() ? result : resultWithActiveOnlySet
        } else { //If there is no keywordSet then result is intersection of all other sets
            result = this.safeIntersection(this.manageableUsersNodeSet, this.activeOnlySet)
            result = this.safeIntersection(result, this.selectedOnlySet)
        }

        return result
    }

    getVisibleNodeSet(selectedNodeSet) {
        const visibleUserNodes = this.safeIntersection(super.getVisibleNodeSet(selectedNodeSet), this.manageableUsersNodeSet)
        const visibleGroupNodes = this.accessibleParentNodes.intersection(selectedNodeSet)
        return visibleUserNodes.union(visibleGroupNodes)
    }

    setShowUsersFromMyTeamOnly(fromMyTeam) {
        if (fromMyTeam) {
            this.manageableUsersNodeSet = this.myTeamNodesSet
        } else {
            this.manageableUsersNodeSet = null
        }

        this.reFilter()
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/ReportsUsersSelectorFilter.js